import { Script, graphql } from 'gatsby'
import React from 'react'

type DisqusBlock = {
  _template?: string
  css_class_name?: string
  settings: any
  src: string
  timeout_duration?: number
  append_to_head?: boolean
  defer?: boolean
  is_external?: boolean
  on_script_load?: () => void
}

const Disqus: React.FC<{block: DisqusBlock}> = ({ block }) => {
  /*
  * There is a style hack .container--disqus { max-width } in _blog-hero.scss
  */
  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className="container container--disqus">
        <div id="disqus_thread" />
      </div>
      <Script src={block.src} strategy="idle" data-timestamp={`${new Date()}`} />
    </section>
  )
}

export const DisqusQuery = graphql`
  fragment DisqusFragment on Block {
    src
    timeout_duration
    append_to_head
    defer
    is_external
  }
`

export default Disqus
